export default {
  left: {
    group: 'My group',
    location: 'Schedule location',
    description: 'Schedule description',
    scoreChart: 'Score sheet',
    scoreChartDescription: 'Score sheet description',
  },
  logout: 'logout',
  right: {
    interviewerList: 'Candidates List',
    average: 'Average score',
    max: 'Highest score',
    min: 'Lowest score',
    searchPlaceholder: 'Name',
    groupScore: 'Group Score',
    allStart: 'Start all',
    startInterview: 'Start Interview',
    endInterview: 'End Interview',
    number: 'No.',
    idCard: 'National ID',
    score: 'score',
    averageScore: 'average grade',
    class: 'class',
    checkedIn: 'Checked in',
    checkIn: 'Check in',
    changeScore: 'Change the score',
    setScore: 'Rate',
  },
  noCheckedInTips: 'There are unregistered candidates in this group',
  noEntryTip: 'No candidates available for rating',
  confirm: 'Confirm ',
  error401: 'Login expired, please login again',
  signOutConfirm: 'Sign out of the interview scoring system?',
  signOutCancel: 'signout cancel',
  status: {
    unsubmitted: 'In progress',
    waiting: 'Not started',
    interviewing: 'In progress',
    complete: 'Complete',
    processing: 'Finished',
    confirmed: 'Finished',
    unconfirmed: 'Unconfirmed',
  },
  allStartConfirm: [
    'Confirm the start of grading of all candidates in this session?',
    'Upon confirmation, your team members may grade all candidates in this session.',
  ],
  startInterviewConfirm:
    'You are about to start the interview. Once started, this action cannot be undone. Please confirm if you wish to continue.',
  endInterviewConfirm: 'Once the interview is ended, it cannot be restored. Please confirm if you wish to proceed.',
  endInterviewConfirmButtonText: 'End Interview',
};
